import Drawer, { Props as DrawerProps } from '../../../../components/Drawer';
import TileDrawerStepper from '../../../shared/TileDrawerStepper';
import AttendanceSteps, { Steps } from '../AttendanceSteps';
import DrawerHeader from '../DrawerHeader';

export interface AttendanceDrawerProps extends Pick<DrawerProps, 'open' | 'onClose'> {}

export const AttendanceDrawer = ({ open, onClose }: AttendanceDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} anchor="right">
      <TileDrawerStepper header={<DrawerHeader />} steps={Steps}>
        {({ currentStep, goToNextStep }) => (
          <AttendanceSteps currentStep={currentStep} goToNextStep={goToNextStep} />
        )}
      </TileDrawerStepper>
    </Drawer>
  );
};

export default AttendanceDrawer;
